import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Assuming you have the images imported
import rightArrowIcon from '../Images/shop.png';  // Replace with your actual image path

const SampleSection = () => {

  const navigate = useNavigate();
  const [freeSampleImage, setFreeSampleImage] = useState('');

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch('https://backend.printtrio.co.uk/api/home/get-setting', {
          headers: { 'Accept': 'application/json' },
        });
        const result = await response.json();
        if (result.success && result.data.length > 0) {
          setFreeSampleImage(result.data[0].free_sample_image);
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImage();
  }, []);

  const handleSampleClick = () => {
    navigate('/sample', { state: { scrollToPromo: true } })
  };
  return (
    <div className="flex flex-col bg-white max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
      <div className="p-6 md:p-12 px-0 md:px-12 xl:px-48 mb-10 w-full mt-10">
        <div 
          className="flex flex-col md:flex-row md:items-center rounded-xl shadow-lg overflow-hidden backdrop-blur-sm w-full"
          style={{ 
            backgroundImage: `url(${freeSampleImage})`,
            backgroundSize: 'contain', 
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            aspectRatio: '16 / 6',
          }}
        >
          <div className="p-0 mt-0 md:mt-0 pl-3 md:pl-16 text-center text-start">
            <p className="text-md md:text-xl xl:text-3xl font-semibold text-white mt-2 md:mt-0 mb-0 md:mb-5" 
               style={{ fontFamily: 'arial' }}>
              Get a Sample Pack
            </p>
            <h2 className="text-xs md:text-md lg:text-xl md:font-semibold text-white mb-4 md:mb-0 w-40 md:w-80 lg:w-full max-w-2xl " 
                style={{ fontFamily: 'arial' }}>
             Order a sample pack to experience the <br/> print quality firsthand.
            </h2>
            
            <button 
             className="mt-0 md:mt-8 text-xs md:text-sm inline-flex items-center bg-white px-4 md:px-6 py-2 md:py-3 rounded-full tracking-wide shadow"
             style={{ fontFamily: 'arial', color: '#191919' }}
              onClick={handleSampleClick}
            >
              Get A Sample
              <img src={rightArrowIcon} alt="arrow" style={{ marginLeft: '8px', width: '16px', height: '16px' }}  />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default SampleSection;
